import styled from "styled-components";
import { apolloFontFamilyBodySmall, apolloFontSizeBodySmall, apolloFontWeightBodySmall, apolloLineHeightBodySmall, apolloSpaceInline1X, apolloSpaceInline3X, apolloSpaceStack1X, apolloSpaceInlineHalfX, } from "@nexthink/apollo-tokens";
import { getValueFromPixelString } from "../../utils/TokenHelpers";
import { getPseudoBeforeBackgroundShadowStyle } from "../checkbox/Checkbox.style";
import Error from "@nexthink/apollo-tokens/lib/images/react/Error";
const radioDiameter = 16;
const radioBulletDiameter = 6;
const errorIconSize = 16;
const StyledWrapperRef = styled.div.withConfig({ displayName: "StyledWrapperRef_APC-7281-productShell", componentId: "sc-1jtbo15" })({});
export const StyledWrapper = styled(StyledWrapperRef).withConfig({ displayName: "StyledWrapper_APC-7281-productShell", componentId: "sc-seqjyo" })(({ display }) => (Object.assign({}, (display === "inline"
    ? {
        display: "inline-flex",
        verticalAlign: "middle",
        marginRight: apolloSpaceInline3X,
        marginTop: 0,
    }
    : {
        display: "flex",
        [`&${StyledWrapperRef} ~ &${StyledWrapperRef}`]: {
            marginTop: apolloSpaceStack1X,
        },
    }))));
export const getPseudoBeforeBorderColor = (theme, disabled, error, checked) => {
    if (disabled) {
        return theme.colors.apolloColorStrokeFormElementDisabled;
    }
    else if (error && checked) {
        return theme.colors.apolloColorStrokeError;
    }
    return theme.colors.apolloColorStrokeFormElementDefault;
};
export const StyledWrapperLabel = styled.label.withConfig({ displayName: "StyledWrapperLabel_APC-7281-productShell", componentId: "sc-1vo1y5q" })(({ theme, checked, disabled, error, focused, label }) => {
    const bulletCenterPostion = (radioDiameter - radioBulletDiameter) / 2 + (focused ? 0 : 1);
    const radioPosition = focused ? 0 : 1;
    return Object.assign(Object.assign(Object.assign(Object.assign({ boxSizing: "border-box", display: "inline-flex", font: `${apolloFontWeightBodySmall} ${apolloFontSizeBodySmall}/${apolloLineHeightBodySmall} ${apolloFontFamilyBodySmall}`, overflow: "hidden", position: "relative" }, (focused
        ? {
            border: `1px solid ${theme.colors.apolloColorStrokeFocus}`,
            boxShadow: theme.colors.apolloBoxShadowFormElementFocusHighlight,
        }
        : { border: "none", boxShadow: "none" })), (disabled
        ? { color: theme.colors.apolloColorTextDisabled, cursor: "auto" }
        : { color: theme.colors.apolloColorTextPrimary, cursor: "pointer" })), (label
        ? {
            height: "100%",
            padding: focused
                ? `0 0 0 ${radioDiameter + getValueFromPixelString(apolloSpaceInline1X)}px`
                : `1px 1px 1px ${1 + radioDiameter + getValueFromPixelString(apolloSpaceInline1X)}px`,
        }
        : {
            height: `${1 + radioDiameter + 1}px`,
            minWidth: `${1 + radioDiameter + 1}px`,
            padding: error && checked
                ? focused
                    ? `0 0 0 ${radioDiameter + getValueFromPixelString(apolloSpaceInlineHalfX)}px`
                    : `1px 1px 1px ${1 + radioDiameter + getValueFromPixelString(apolloSpaceInlineHalfX)}px`
                : "0px",
        })), { "&::before": Object.assign(Object.assign({}, getPseudoBeforeBackgroundShadowStyle(theme, checked, disabled)), { border: `1px solid ${getPseudoBeforeBorderColor(theme, disabled, error, checked)}`, borderRadius: "50%", boxSizing: "border-box", content: "''", display: "inline-block", height: radioDiameter, position: "absolute", left: radioPosition, top: radioPosition, width: radioDiameter }), "&::after": {
            background: disabled
                ? theme.colors.apolloColorFillFormElementSelectedDisabled
                : theme.colors.apolloColorFillFormElementSelected,
            borderRadius: "50%",
            content: "''",
            display: checked ? "inline-block" : "none",
            height: radioBulletDiameter,
            left: bulletCenterPostion,
            position: "absolute",
            top: bulletCenterPostion,
            width: radioBulletDiameter,
        } });
});
export const StyledInput = styled.input.withConfig({ displayName: "StyledInput_APC-7281-productShell", componentId: "sc-sy0b3z" })(({ disabled }) => ({
    opacity: 0,
    position: "absolute",
    cursor: disabled ? "auto" : "pointer",
}));
export const StyledErrorIcon = styled(Error).withConfig({ displayName: "StyledErrorIcon_APC-7281-productShell", componentId: "sc-10dbvtu" })(({ theme }) => ({
    color: theme.colors.apolloColorStrokeError,
    height: errorIconSize,
    width: errorIconSize,
}));
//# sourceMappingURL=Radio.style.js.map